import React, { useState } from 'react'
import { useAuth } from '@/contexts/AuthContext'
import { Navigate } from 'react-router-dom'

export default function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const { user, login } = useAuth()
  const role = user?.role?.toLowerCase()

  if (user) {
    if (role === 'investor') {
      return <Navigate to="/investor" replace />
    }
    return <Navigate to="/upload" replace />
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      await login(email, password)
    } catch (error) {
      // Error is handled in AuthContext
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--color-systemGroupedBackground)',
      fontFamily: 'var(--font-family-appleSystem)',
    }}>
      <div style={{
        background: 'var(--color-card)',
        borderRadius: 'var(--border-radius-modal)',
        boxShadow: 'var(--shadow-appleModal)',
        padding: 'var(--spacing-8)',
        width: '100%',
        maxWidth: 400,
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--spacing-6)',
        border: '1px solid var(--color-border)',
      }}>
        <div style={{ textAlign: 'center' }}>
          <h2 style={{
            fontSize: 'var(--font-size-3xl)',
            fontWeight: 700,
            color: 'var(--color-label)',
            marginBottom: 'var(--spacing-2)',
            letterSpacing: 'var(--letter-spacing-tight)',
          }}>
            Martimart Ads Platform
          </h2>
          <p style={{
            color: 'var(--color-secondaryLabel)',
            fontSize: 'var(--font-size-base)',
            fontWeight: 500,
          }}>
            Sign in to your account
          </p>
        </div>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-4)' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-2)' }}>
            <label htmlFor="email" style={{
              color: 'var(--color-secondaryLabel)',
              fontSize: 'var(--font-size-sm)',
              fontWeight: 500,
              marginBottom: 4,
              textAlign: 'left',
            }}>
              Email address
            </label>
            <input
              id="email"
              name="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: '100%',
                padding: 'var(--spacing-2) var(--spacing-2)',
                borderRadius: 'var(--radius-input)',
                border: '1px solid var(--color-border)',
                background: 'var(--color-systemBackground)',
                color: 'var(--color-label)',
                fontSize: 'var(--font-size-base)',
                fontFamily: 'inherit',
                outline: 'none',
                transition: 'var(--transition-borderColor)',
                marginBottom: 0,
              }}
              autoComplete="username"
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-2)' }}>
            <label htmlFor="password" style={{
              color: 'var(--color-secondaryLabel)',
              fontSize: 'var(--font-size-sm)',
              fontWeight: 500,
              marginBottom: 4,
              textAlign: 'left',
            }}>
              Password
            </label>
            <input
              id="password"
              name="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: '100%',
                padding: 'var(--spacing-2) var(--spacing-2)',
                borderRadius: 'var(--radius-input)',
                border: '1px solid var(--color-border)',
                background: 'var(--color-systemBackground)',
                color: 'var(--color-label)',
                fontSize: 'var(--font-size-base)',
                fontFamily: 'inherit',
                outline: 'none',
                transition: 'var(--transition-borderColor)',
                marginBottom: 0,
              }}
              autoComplete="current-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: 'var(--spacing-4) 0',
              borderRadius: 'var(--radius-button)',
              background: 'var(--color-primary)',
              color: 'var(--color-systemBackground)',
              fontWeight: 600,
              fontSize: 'var(--font-size-lg)',
              border: 'none',
              boxShadow: 'var(--shadow-button)',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 'var(--opacity-disabled)' : 1,
              transition: 'var(--transition-backgroundColor), var(--transition-opacity)',
              marginTop: 'var(--spacing-2)',
            }}
          >
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  )
} 